import { defineMessages } from 'react-intl';

import { SportTermLookup, SportTerminology } from '../../lib/types';
import { pluralTerm } from '../../lib/helpers/term.helper';

export const scope = 'app.components.Report';

export const getMessages = (termLookup: SportTermLookup) => {
  const sessionsTerm = pluralTerm(termLookup[SportTerminology.SESSION]);

  return defineMessages({
    lblLastChecked: {
      id: `${scope}.lblLastChecked`,
      defaultMessage: 'Reports are re-evaluated every {minutes} minutes (last checked at {time})'
    },
    lblProcessingDelay: {
      id: `${scope}.lblProcessingDelay`,
      defaultMessage: `Recently scored ${sessionsTerm} may take a few extra minutes to finish processing before their updates appear here.`
    },
    btnExportReport: {
      id: `${scope}.btnExportReport`,
      defaultMessage: 'Export Report'
    },
    btnExportWithContacts: {
      id: `${scope}.btnExportWithContacts`,
      defaultMessage: 'Export with Contact Info'
    },
    lblPositionFilter: {
      id: `${scope}.lblPositionFilter`,
      defaultMessage: 'Position:'
    },
    lblLevelFilter: {
      id: `${scope}.lblLevelFilter`,
      defaultMessage: 'Level:'
    },
    lblTeamFilter: {
      id: `${scope}.lblTeamFilter`,
      defaultMessage: 'Team:'
    },
    lblReportCardFilter: {
      id: `${scope}.lblReportCardFilter`,
      defaultMessage: 'Report card:'
    },
    lblFilterOptionCount: {
      id: `${scope}.lblFilterOptionCount`,
      defaultMessage: '{label} ({count})'
    },
    lblShowConcluded: {
      id: `${scope}.lblShowConcluded`,
      defaultMessage: 'Show Concluded:'
    },
    lblConcludedHidden: {
      id: `${scope}.lblConcludedHidden`,
      defaultMessage: '{count} concluded {athletes} {verb} hidden because Show Concluded is off.'
    },
    btnShowConcluded: {
      id: `${scope}.btnShowConcluded`,
      defaultMessage: 'Show them'
    }
  });
};
